// src/pages/usa/colorado/GlenwoodSprings.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Glenwood Springs ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function GlenwoodSprings() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__glenwoodSpringsBackRouteSet) {
      window.__glenwoodSpringsBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Glenwood Springs, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>🏞️ Discover Glenwood Springs, Colorado</h2>

            <p>
              Glenwood Springs is a charming mountain town known for its natural hot springs, dramatic canyon
              scenery, and outdoor recreation. Whether you're soaking in mineral pools or exploring the surrounding
              wilderness, Glenwood Springs offers a relaxing yet adventurous escape.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              The drive from Denver to Glenwood Springs takes about 3 hours via I‑70 West. The route is incredibly
              scenic — especially through Glenwood Canyon. You can also take the Amtrak train from Denver’s Union
              Station, which takes about 3.5 to 4 hours and offers stunning canyon views.
            </p>

            {/* 🌟 PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Glenwood Hot Springs Pool:</strong> The world’s largest hot springs pool with multiple
                  soaking areas, mountain views, and full amenities.<br />
                  <a
                    href="https://www.google.com/maps?q=39.549624499032916,-107.32262435562677"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Map
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Iron Mountain Hot Springs:</strong> A peaceful riverside hot springs with 16 soaking pools,
                  a cold plunge, and beautiful views.<br />
                  <a
                    href="https://www.google.com/maps?q=39.555221228895455,-107.33620102933129"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Map
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hanging Lake:</strong> A must‑do hike to a turquoise lake perched on a cliff. Permit
                  required.<br />
                  <a
                    href="https://www.google.com/maps?q=39.58947319277111,-107.19026004473231"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Trailhead Parking
                  </a>
                  <br />
                  <a
                    href="https://www.google.com/maps?q=39.60136364595648,-107.19175259345988"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Hanging Lake
                  </a>
                </div>
              </li>
            </ul>

            {/* 🥾 HIDDEN GEMS */}
            <h3>🥾 Hidden Gems in Glenwood Springs</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Glenwood Caverns Adventure Park:</strong> Mountaintop theme park with cave tours and thrill rides.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Shoshone Rapids:</strong> Class III–IV rapids in Glenwood Canyon — great for rafting.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Glenwood Canyon Recreation Path:</strong> Scenic paved trail along the Colorado River.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Rio Grande Trail:</strong> Long‑distance bike path connecting Glenwood Springs to Aspen.
                </div>
              </li>
            </ul>

            {/* 🛏️ PLACES TO STAY */}
            <h3>🛏️ Places to Stay in Glenwood Springs</h3>

            <p>I’ve stayed in Glenwood Springs multiple times and can personally recommend these:</p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Courtyard by Marriott Glenwood Springs:</strong> Clean, modern, quiet, and well‑located.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Residence Inn by Marriott:</strong> Spacious suites and friendly staff.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Hotel Glenwood Springs:</strong> Next to the gondola and close to Iron Mountain Hot Springs.
                </div>
              </li>
            </ul>

            {/* AFFILIATE BLOCK */}
            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                        <div className="affiliate-block">
                          <AffiliateExpedia />
                          <AffiliateBooking />
                          <AffiliateTrip />
                        </div>
            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here is a video I took from the canyon when driving back to Denver!</p>

            <p>
              <a
                href="https://youtu.be/3inRHuchhRw?si=62mDrGSWuo-S_7P5"
                target="_blank"
                rel="noopener noreferrer"
              >
                Glenwood Canyon
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN — IMAGES */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/3inRHuchhRw?si=62mDrGSWuo-S_7P5"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/glenwood/canyon.jpg"
                alt="Glenwood Canyon Video"
                loading="lazy"
              />
            </a>

            <img src="/images/usa/colorado/glenwood/town.jpg" alt="Town View from Gondola" loading="lazy" />
            <img src="/images/usa/colorado/glenwood/viewofthetown.jpg" alt="Town View from Above" loading="lazy" />
            <img src="/images/usa/colorado/glenwood/glenwoodpool.jpg" alt="Glenwood Hot Springs Pool" loading="lazy" />
            <img src="/images/usa/colorado/glenwood/glenwoodpool2.jpg" alt="Glenwood Hot Springs Pool" loading="lazy" />
            <img src="/images/usa/colorado/glenwood/iron.jpg" alt="Iron Mountain Hot Springs" loading="lazy" />
            <img src="/images/usa/colorado/glenwood/hanginglake1.jpg" alt="Hanging Lake" loading="lazy" />
            <img src="/images/usa/colorado/glenwood/hanginglake2.jpg" alt="Hanging Lake" loading="lazy" />
            <img src="/images/usa/colorado/glenwood/hanginglake3.jpg" alt="Hanging Lake" loading="lazy" />
            <img src="/images/usa/colorado/glenwood/sunset.jpg" alt="Sunset" loading="lazy" />
            <img src="/images/usa/colorado/glenwood/hotspringandtheriver.jpg" alt="Hot Spring and River View" loading="lazy" />
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
